import React from 'react';
import { useTranslation } from 'react-i18next';

const Toolbar = ({ attributes, onDragAttribute }) => {
    const { t } = useTranslation([
        "display/components/form"
    ]);
    return (
        <>
            <p className='font-size-1 font-weight-2 my-3'>
                {t("toolbar_title", { ns: "display/components/form" })}
            </p>
            {attributes.map(attribute => {
                return (
                    <div
                        key={attribute.attributeId}
                        className="droppable-element border border-secondary p-2 my-3 me-3 rounded text-center font-weight-bold cursor-pointer bg-light form-buiider-label"
                        dataId={attribute._id}
                        draggable
                        title={attribute.attributeName}
                        onDragStart={() => onDragAttribute(attribute._id)}
                    >
                        {attribute.attributeLabel}
                    </div>
                )
            })}
            {attributes.length === 0 &&
                <div className="d-flex align-items-center justify-content-center my-3">
                    <img width={500} src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/dragAndDrop.jpg`} alt="responsive webite" className="img-fluid" />
                </div>
            }
        </>
    )
}

export default Toolbar